
import React from 'react';
import Head from 'next/head';
import { connect } from 'react-redux';
import { logout, switchMode, getSaltKey, getRefreshToken, saveEventsData, sendContactForm } from '../src/actions/actions';
import FixedFooter from '../src/common/fixed-footer';
import CONFIG, { LOGO_URL, SHOW_FOOTER_FOR_STATIC_PAGES } from '../src/config';
import OverView from '../src/components/advertise/overview';
import Audience from '../src/components/advertise/audience';
import AdFormat from '../src/components/advertise/ad-format';
import AdvertiseWithUs from '../src/components/advertise/advertis-with-us';
import dynamic from 'next/dynamic';

const Header = dynamic(import('../src/components/header'), { ssr: false });
const Footer = dynamic(import('../src/components/footer'), { ssr: false });

// help page
class Advertise extends React.Component {
    setIndex = (id) =>  {
        let el = document.getElementById(id);
        if(el) {
            el.click();
        }
    }
    render() {
        const { isAuth, user, logout, meta_data, darkTheme, pages, switchMode, popularSearch} = this.props;
        const showFooter = SHOW_FOOTER_FOR_STATIC_PAGES;
        return (
            <>
                <Head>
                    <title>{meta_data.meta_title}</title>
                    <meta name="description" content={meta_data.meta_description}/>
                    <meta name="keywords" content={meta_data.meta_keyword}/>
                    <meta property="og:url" content={CONFIG.SITE_URL+"/"+meta_data.name}/>
                    <meta property="og:title" content={meta_data.meta_title}/>
                    <meta property="og:keywords" content={meta_data.meta_keyword}/>
                    <meta property="og:site_name" content={CONFIG.APP_NAME}></meta>
                    <meta property="og:description" content={meta_data.meta_description}></meta>
                    <meta property="og:image" content={LOGO_URL}></meta>
                    <meta property="og:description" content={"Terms and Conditions - "+CONFIG.APP_NAME}></meta>
                    <link rel="canonical" href={meta_data.url} />
                </Head>
                <div className={darkTheme ? "dark_theme" : "light_theme"}>
                    <Header user={user} isAuth={isAuth} logout={logout} darkTheme={darkTheme} switchMode={switchMode} pages={pages}/>
                    <div className="bg-header position-sticky-top remove-native" style={{ zIndex: 1 }}>
                        <h1 className="static-title ps-xl-5 ps-lg-3 ps-2 ms-2 mt-xl-4 mt-lg-3 mt-2">Advertise</h1>
                    </div>
                    <div className="container homepage contact-us px-xl-5 px-lg-4 px-2 overflow-inherit">
                        <div className="row remove-native justify-content-center advertise-page">
                            <div className="col-xxl-11 col-12 justify-content-center">
                                <ul className="nav nav-pills my-3 d-flex justify-content-center" id="pills-tab" role="tablist">
                                    <li className="nav-item mx-md-2 mx-1" role="presentation">
                                        <button className="nav-link h5 active rounded-1" id="pills-overview-tab" data-bs-toggle="pill" data-bs-target="#pills-overview" type="button" role="tab" aria-controls="pills-overview" aria-selected="true">Overview</button>
                                    </li>
                                    <li className="nav-item mx-md-2 mx-1" role="presentation">
                                        <button className="nav-link h5 rounded-1" id="pills-audience-tab" data-bs-toggle="pill" data-bs-target="#pills-audience" type="button" role="tab" aria-controls="pills-audience" aria-selected="false">Audience</button>
                                    </li>
                                    <li className="nav-item mx-md-2 mx-1" role="presentation">
                                        <button className="nav-link h5 rounded-1" id="pills-ad-format-tab" data-bs-toggle="pill" data-bs-target="#pills-ad-format" type="button" role="tab" aria-controls="pills-ad-format" aria-selected="false">Ad format</button>
                                    </li>
                                    <li className="nav-item mx-md-2 mx-1" role="presentation">
                                        <button className="nav-link h5 rounded-1" id="pills-advertise-us-tab" data-bs-toggle="pill" data-bs-target="#pills-advertise-us" type="button" role="tab" aria-controls="pills-advertise-us" aria-selected="false">Advertise with us</button>
                                    </li>
                                </ul>
                                <div className="tab-content" id="pills-tabContent">
                                    <div className="tab-pane fade show active" id="pills-overview" role="tabpanel" aria-labelledby="pills-overview-tab" tabIndex={0}>
                                        <OverView setIndex={this.setIndex}/>
                                    </div>
                                    <div className="tab-pane fade" id="pills-audience" role="tabpanel" aria-labelledby="pills-audience-tab" tabIndex={0}>
                                        <Audience setIndex={this.setIndex}/>
                                    </div>
                                    <div className="tab-pane fade" id="pills-ad-format" role="tabpanel" aria-labelledby="pills-ad-format-tab" tabIndex={0}>
                                        <AdFormat setIndex={this.setIndex}/>
                                    </div>
                                    <div className="tab-pane fade" id="pills-advertise-us" role="tabpanel" aria-labelledby="pills-advertise-us-tab" tabIndex={0}>
                                        <AdvertiseWithUs
                                            {...this.props}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <Footer
                        showFooter={showFooter}
                        pages={pages}
                    />
                </div>
                <FixedFooter/>
            </>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.AppReducer.user, // If user logged you will get the user object
        isAuth: state.AppReducer.isAuth, // isAuth is used to detect if user is logged in or not
        metaData: state.AppReducer.metaData,
        darkTheme: state.AppReducer.darkTheme,
        labels: state.AppReducer.labels
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => dispatch(logout()),
        switchMode: (theme) => dispatch(switchMode(theme)), // Switch theme
        getSaltKey: (data) => dispatch(getSaltKey(data)),
        getRefreshToken: (data) => dispatch(getRefreshToken(data)),
        saveEventsData: (data) => dispatch(saveEventsData(data)),
        sendContactForm: (data, header) => dispatch(sendContactForm(data, header))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Advertise);


// Initial page - This is default function from Next.js to load data when page is hitting from browser - SSR(Single Side Rendering);

export async function getStaticProps() {
    let name = "Advertise";
    return {
        props: {
            meta_data: {
                name: name,
                meta_title: name.charAt(0).toUpperCase() + name.split("-").join(" ").slice(1) + "  | "+CONFIG.APP_NAME,
                meta_description: name.charAt(0).toUpperCase() + name.split("-").join(" ").slice(1) + "  | "+CONFIG.APP_NAME,
                meta_keyword: name,
                url: process.env.HOST+"/"+name
            }
        }
    }
}